import React, { useEffect } from "react";
import {
  format,
  differenceInMinutes,
  parseISO,
  setHours,
  setMinutes,
} from "date-fns";
import DatePicker from "react-datepicker";

import {
  useFormatReservationDate,
  createFilterPassedTime,
} from "../../../lib/datePickerHelper";
import { useBookingsMapContext } from "../../Context/BookingsMapContext";
import { toZonedTime } from "date-fns-tz";
import { useTimeZoneContext } from "../../../../../lib/context/TimeZone/TimeZoneContext";

import { DaySelectorInput } from "../../../../shared/Forms/DaySelectorInput/DaySelectorInput";
import { timePickerProps } from "../../../helpers/timePickerProps";

import "react-datepicker/dist/react-datepicker.css";

export const SelectTimeModal = () => {
  const { time, handleTime, handleDay, day, dateAndTime } =
    useBookingsMapContext();
  const { timeZone } = useTimeZoneContext();

  const filterPassedTime = createFilterPassedTime(day, timeZone);

  useEffect(() => {
    handleDay(format(toZonedTime(new Date(day), timeZone), "yyyy-MM-dd"));

    if (
      new Date(dateAndTime) > new Date() ||
      differenceInMinutes(new Date(dateAndTime), new Date()) === -0
    ) {
      return;
    }

    handleTime(toZonedTime(new Date(), timeZone));
  }, [timeZone]);

  return (
    <div className="SelectTimeModal">
      <h6>Select time for map view</h6>
      <DaySelectorInput
        customDateVariant="room"
        onChange={(value) => {
          if (!value) {
            return;
          }
          handleDay(value.value);
        }}
        value={{
          label: useFormatReservationDate(parseISO(day)),
          value: day,
        }}
      />

      <DatePicker
        {...timePickerProps}
        selected={time}
        onChange={(date: Date | null) => {
          if (!date) {
            return;
          }
          handleTime(date);
        }}
        className="SearchWorkplaceForm__timePicker"
        filterTime={filterPassedTime}
        injectTimes={[setHours(setMinutes(new Date(), 59), 23)]}
      />
    </div>
  );
};
